// initial state
const state = {
    padList: {
      selectedPad: {},
      index: "",
      padList: [],
      controlList: [],
      clipHistory: [],
      allPads: []
    },
  };
  
  // getters
  const getters = {};
  
  // actions
  const actions = {};
  
  // mutations
  const mutations = {
    setSelectedPad(state, selectedPad) {
      //设置参数
      state.selectedPad = selectedPad;
    },
    setSelectedIndex(state, index) {
      state.index = index;
    },
    setControlList(state, controlList){
      state.controlList = controlList;
    },
    setPadList(state, padList){
      state.padList = padList;
    },
    setAllPads(state, allPads){
      state.allPads = allPads;
    },
    setClipHistory(state, clipHistory){
      state.clipHistory = clipHistory;
    },
    clearClipHistory(state){
      state.clipHistory = '';
    }
  };
  
  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  };
  


// WEBPACK FOOTER //
// ./src/store/module/padList.js